export const fontFamilyLight = 'Satoshi-Light';
export const fontFamily = 'Satoshi-Regular';
export const fontFamilyBold = 'Satoshi-Bold';
export const fontFamilyBlack = 'Satoshi-Black';
export const fontFamilyHeader = 'Satoshi-Black';
export const fontFamilyDisplayHeader = 'Satoshi-Black';

/* Font size */
export const fontSizeText = {
  xsmall: '1rem',
  small: '1.2rem',
  medium: '1.4rem',
  large: '1.6rem',
  xlarge: '1.8rem',
};

export const buttonFontSize = {
  medium: '1.2rem',
};

/* Body text */
export const lineHeights = {
  text: '1.5',
  header: '1.2',
  displayHeader: '1.2',
};
export const fontWeights = {
  light: '300',
  text: '400',
  bold: '700',
  displayHeader: '800',
  black: '900',
};

/* Headers */
export const fontSizeHeader = {
  desktop: {
    h1: '3.981rem',
    h2: '3.318rem',
    h3: '2.765rem',
    h4: '2.304rem',
    h5: '1.920rem',
    h6: '1.6rem',
  },
  mobile: {
    h1: '2.883rem',
    h2: '2.563rem',
    h3: '2.278rem',
    h4: '2.025rem',
    h5: '1.8rem',
    h6: '1.6rem',
  },
};

export const fontSizeDisplayHeader = {
  desktop: {
    large: '8.256rem',
    medium: '6.880rem',
    small: '5.733rem',
    xsmall: '4.778rem',
  },
  mobile: {
    large: '4.618rem',
    medium: '4.105rem',
    small: '3.649rem',
    xsmall: '3.244rem',
  },
};
